<script setup>
import { useWhiteLabel } from '@/store/useWhitelabel';

const {
    copyrightName,
    copyrightYear,
    trademarked,
    registered
} = useWhiteLabel();
</script>

<template>
    <v-footer class="PageFooter">
        <p
            class="mb-0 copyright"
        >
            <span>
                &copy;{{ copyrightYear }} {{
                    copyrightName
                }}<span v-if="trademarked">&trade;</span><span v-if="registered">&reg;</span>
            </span>
        </p>
    </v-footer>
</template>

<style lang="scss">
.PageFooter {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    height: auto;
    margin-top: auto !important;
}

.copyright {
    font-size: 12px !important;
}
</style>
